import { jsonPost } from 'api'

const isCreateTokenResponseSuccessful = response => {
    if (response.successful !== true) throw new Error('Unable to create credit card token!')

    return response
}

export const createCCToken = temporaryToken =>
    jsonPost(
        `${MONERIS_GATEWAY}`,
        { temporaryToken },
        {
            'X-Api-Key': THINX_BASE_API_URL_API_KEY,
        }
    )
        .then(isCreateTokenResponseSuccessful)
        .catch(error => {
            throw new Error(error.message)
        })
